import styled from 'styled-components';
import { Grid, Utils } from 'billon-ui';

const { Row, Col } = Grid;
const { Button: ButtonModule } = Utils;
const { Button } = ButtonModule;

export const FlexEndRow = styled(Row)`
  justify-content: flex-end;
`;

export const AllCol = styled(Col)``;

export const ButtonCol = styled(Col)`
  align-self: flex-end;
  @media (min-width: 768px) {
    display: flex;
    justify-content: flex-end;
    margin-top: -24px;
    margin-bottom: 8px;
  }
`;

export const FlexEndButton = styled(Button)`
  @media (min-width: 1400px) {
    padding: 0.5rem 3.5rem;
  }
`;
